import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'signaturit-text-area',
  templateUrl: './text-area.component.html',
  styleUrls: ['./text-area.component.scss']
})
export class TextAreaComponent {

  @Input() id: string;

  @Input() labelName: string;

  @Input() placeholderName: string;

  @Input() isRequired: boolean = false;

  @Input() inputWidth: string;

  @Input() inputHeight: string;

  @Input() inputValue: string = '';

  @Input() isDisabled: boolean = false;

  @Input() maxLength: number = 9999;

  @Input() minLength: number = 1;

  @Input() innerHTMLLabel: InnerHTML;

  @Output('outputValue') outputValue: EventEmitter<string> = new EventEmitter<string>();

  constructor() { }

  changeText(): void {
    this.outputValue.emit(this.inputValue);
  }

}
